module.exports = __webpack_public_path__ + "static/media/list-bg1.2b867f74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/list-bg1.jpg
// module id = 324
// module chunks = 0